// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1___60691eb59e5ddcfbf4f","cls2":"PostEngagementFollowPrompt-cls2__b2b3fb5a73c8de74f752 PostEngagementFollowPrompt-cls1___60691eb59e5ddcfbf4f"};